import { FC } from 'react'

// Mesma heurística usada em webSocketHelper.ts e nos demais pontos do app que
// distinguem homologação de produção pelo hostname (não há REACT_APP_* dedicado).
const isHomologacao = (): boolean => {
  const hostname = window.location.hostname
  return hostname.includes('homolog') || hostname.includes('localhost')
}

export const HomologacaoStripe: FC = () => {
  if (!isHomologacao()) {
    return null
  }

  return (
    <div
      className='homologacao-stripe w-100 d-flex align-items-center px-5 py-2'
      style={{ backgroundColor: '#C2410C' }}
    >
      <span
        className='fw-bold text-nowrap text-white fs-8'
        style={{ fontFamily: 'Archivo, sans-serif', letterSpacing: '.12em' }}
      >
        <span className='homologacao-stripe-full'>AMBIENTE DE HOMOLOGAÇÃO</span>
        {/* Rótulo curto exibido com o menu lateral recolhido */}
        <span className='homologacao-stripe-short' aria-hidden='true'>
          HML
        </span>
      </span>
    </div>
  )
}
